import modalStyle from "../modalStyle";

const searchDialogStyle = theme => ({
    ...modalStyle(theme)
});

export default searchDialogStyle;